import { PaginatedCards } from '../../types/card';
import { formatCountryDisplay, filterBlacklistedCountries } from '../../helpers/countries';
import { useTranslations } from 'next-intl';

export const useProductData = ({ initialCountries, initialProducts, initialCategories }: { initialCountries: string[], initialCategories: string[], initialProducts: PaginatedCards }) => {
  const t = useTranslations('categories');
  const cards = initialProducts?.items ?? [];
  const totalCards = initialProducts.total;

  const categories = initialCategories.map((categorySlug: string) => ({
    id: categorySlug,
    name: t(`${categorySlug}.name`)
  }));

  const countries = filterBlacklistedCountries(initialCountries).map((country: string) => ({
    id: country,
    name: formatCountryDisplay(country)
  }));

  return {
    loading: false,
    cards,
    totalCards,
    categories,
    countries,
    fetchCards: () => {}
  };
};
